import { type GetHookResponse } from '../hooks'
import { questionKey } from '../keys'
import { useTantalimQuery } from '../query'
import {
  DAY,
  HOUR,
  type QuestionData,
  type QuestionGetInput,
  type QuestionGetSuccess,
  type QuestionId,
} from '@terros/common'

export function useQuestion(questionId: QuestionId): GetHookResponse<QuestionData> {
  return useTantalimQuery<QuestionGetInput, QuestionGetSuccess, QuestionData>({
    url: '/question/manage/get',
    queryKey: questionKey(questionId),
    input: { questionId },
    convertResponse: (data) => data.question,
    options: {
      gcTime: HOUR,
      staleTime: DAY,
    },
  })
}
